import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import Divider from '@material-ui/core/Divider';
import TimeAgo from "react-timeago";
import Icon from '@material-ui/core/Icon';
import { Link } from "routes";
import styled from 'styled-components';
import {getMobileNewsItemVideoThumbnail, extractYoutubeVideoID} from '/utils/common'
import SponsorChip from '/components/sponsorChip';
import ImgThumbnailSmall from '/components/imgThumbnailSmall';
import classNames from 'classnames';
import fontUniOrConvertZawgyi from '/utils/fontUniOrConvertZawgyi';
import BrandTeaserLogo from '/components/brandTeaserLogo';
import VideoCardParts from '/components/Video/VideoCardParts';
import VideoCardPoster from "/components/Video/VideoCardPoster";
import PlayIconButton from "/components/playIconButton";
import { compose } from 'recompose';
import withWidth from '@material-ui/core/withWidth';
import VideoDetailUpNextItem from './VideoDetailUpNextItem';

const styles = theme => ({
  textContainer: {
    padding: '0px 0px 0px 14px'
  },
  img: {
    background: 'rgba(128, 128, 128, 0.11)',
    margin: 'auto',
    display: 'block',
    maxWidth: '100%',
    maxHeight: '100%',
    width: '100%',
    height: 100,
    objectFit: 'cover'
  },
  customDivider: {
    margin: '14px 0px 14px',
    backgroundColor: '#312e2e'
  },
  playerIconStyle: {
    color: '#ed7123',
    position: 'absolute',
    bottom: 2,
    left: 2,
    fontSize: 25
  },
  playerIconWrapperStyle: {
    width: 32,
    height: 32, 
    background: '#fff',
    position: 'absolute',
    borderRadius: '50%',
    bottom: 5,
    left: 4,
    border: '2px solid #ed7123'
  },

});

class VideoDetailUpNext extends React.Component {
  render(){
  const { items, classes, className, playlist, playlistPos, newsItems } = this.props;
  let playlistId = playlist ? playlist.playlist_id : null;
  let isDesktopPlaylist = this.props.width != 'xs' && playlistId
  return (
    <div className={isDesktopPlaylist ? 'playlistUpnextRoot' : ''} style={isDesktopPlaylist ? { maxHeight: 341, overflowY: 'scroll',  flexGrow: 1,
    padding: '0px 0px  14px',} : { flexGrow: 1,padding: '0px 0px  14px',}}>
    {
      items && items.map((item, i) => {
          return(            
            <VideoDetailUpNextItem 
            key={i} 
            isSmallPoster={this.props.width === 'xs'} 
            keyIndex={i} 
            item={item} 
            playlistPos={playlistPos} 
            className={className} 
            isDesktopPlaylist={isDesktopPlaylist} 
            playlistId={playlistId} />
          )
      })
    }
     {
      newsItems && newsItems.map((item, i) => {
          return(            
            <VideoDetailUpNextItem 
            key={i} 
            isSmallPoster={this.props.width === 'xs'} 
            keyIndex={i} 
            item={item} 
            playlistPos={playlistPos} 
            className={className} 
            isDesktopPlaylist={isDesktopPlaylist} 
            playlistId={playlistId} />
          )
      })
    }
    </div>
  );
}
}

VideoDetailUpNext.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default compose(
  withWidth(),
  withStyles(styles))(VideoDetailUpNext);